// extracted by mini-css-extract-plugin
export default {"button":"TeamSelector_button__BIOXt","teams":"TeamSelector_teams__Qtjf8","team":"TeamSelector_team__WHDPY","name":"TeamSelector_name__PphQz","members":"TeamSelector_members__14bdF"};